var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ttns.length)?_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.openModal.apply(null, arguments)}}},_vm._l((_vm.ttns),function(ttn){return _c('el-row',{key:ttn.id,class:[
      'response-ttns',
      _vm.response['ttn-status'],
      { 'text-align-left': _vm.value } ],domProps:{"innerHTML":_vm._s(_vm.getTTNInfo(ttn))}})}),1):_c('div',{staticClass:"response-act danger"},[_vm._v("ТТН")])}
var staticRenderFns = []

export { render, staticRenderFns }